import "./instrument.js";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary
        fallback={
          <div style={{ padding: "2rem", textAlign: "center" }}>
            <h1>Une erreur inattendue est survenue</h1>
            <p>Notre équipe a été notifiée. Veuillez rafraîchir la page.</p>
          </div>
        }
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
